export default __webpack_public_path__ + "static/嘉宾头像_陈彬-ef2984023881098f0f3c6ef7b2a3dd83.png";